import React, { memo } from "react";
import { LinearProgress, makeStyles, Theme } from "@material-ui/core";

interface IProps {
	show: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
	container: {
		width: "100%",
		position: "absolute",
		top: 0,
		zIndex: 9999
	}
}));

function Loading(props: IProps) {
	const classes = useStyles();

	if (!props.show) return null;

	return (
		<div className={classes.container}>
			<LinearProgress />
		</div>
	);
}

export default memo(Loading);
